export default __webpack_public_path__ + "static/media/vit-logo.abccfc77.png";